import { compose, eq, get } from "lodash/fp"

export const entityIdEqualsId = (id: string | number) => {
  return compose(eq(id), get("id"))
}
